import type { SxProps, Theme } from "@mui/material/styles";

/** Sticky section navigation tabs on regulation detail page (Details, Related Items, …). */
export const regulationDetailsNavTabsSx: SxProps<Theme> = {
  minHeight: 40,
  "& .MuiTabs-indicator": {
    display: "none",
  },
  "& .MuiTabs-flexContainer": {
    gap: 1,
  },
  "& .MuiTab-root": {
    textTransform: "none",
    fontSize: (theme) => theme.typography.body2.fontSize,
    fontWeight: 500,
    color: "#262626",
    minWidth: "auto",
    minHeight: 40,
    px: 3,
    py: 1,
    borderRadius: "8px 8px 0 0",
    border: "1px solid #e5e7eb",
    borderBottom: "none",
    backgroundColor: "#fafafa",
    marginBottom: "-1px",
    transition: "all 0.2s",
    "&.Mui-selected": {
      color: "#0f172a",
      backgroundColor: "#ffffff",
      borderColor: "#e5e7eb",
      borderBottom: "1px solid #ffffff",
      fontSize: (theme) => theme.typography.subtitle1.fontSize,
      fontWeight: "bold",
      zIndex: 2,
    },
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
};

/** Content panel attached below regulation detail-style tabs. */
export const regulationDetailsNavTabPanelSx: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  minHeight: 0,
  border: "1px solid #e5e7eb",
  borderTop: "none",
  borderRadius: "0 0 8px 8px",
  bgcolor: "background.paper",
  p: 3,
};

/** Underline tabs used inside detail sections and AI Plan page (matches design). */
export const regulationDetailsSectionTabsSx: SxProps<Theme> = {
  minHeight: 48,
  "& .MuiTab-root": {
    textTransform: "none",
    minWidth: "auto",
    px: 2,
    py: 1.5,
    fontSize: "0.875rem",
    fontWeight: 500,
    color: "#6b7280",
    "&.Mui-selected": {
      color: "primary.main",
      fontWeight: 600,
    },
  },
  "& .MuiTabs-indicator": {
    backgroundColor: "primary.main",
    height: 3,
    borderRadius: "3px 3px 0 0",
  },
};

/** Tab strip wrapper for section-style underline tabs. */
export const regulationDetailsSectionTabStripSx: SxProps<Theme> = {
  borderBottom: 1,
  borderColor: "divider",
  bgcolor: "#fff",
  flexShrink: 0,
};

/** Filter toolbar on AI Plan and similar pages. */
export const aiPlanFilterBarSx: SxProps<Theme> = {
  display: "flex",
  gap: 2,
  alignItems: "center",
  flexWrap: { xs: "wrap", md: "nowrap" },
  pt: "10px",
  pb: "10px",
  px: "16px",
  bgcolor: "#ffffff",
  borderRadius: "3px",
  borderBottom: "1px solid #e5e7eb",
};

export const aiPlanFilterFieldSx: SxProps<Theme> = {
  minWidth: 200,
  flex: { xs: "1 1 200px", md: "0 1 auto" },
};
